import { SxProps, Theme } from '@mui/material'
import { UserAvatar } from '../../avatar/UserAvatar'

export const AssigneeAvatar = ({
  option,
  sx,
  size = 20,
}: {
  option: { id: string; value: string }
  sx?: SxProps<Theme>
  size?: 20 | 24
}) => {
  return (
    <UserAvatar
      size={size}
      user={{
        id: option.id,
        firstName: option.value.split(' ')[0] ?? '',
        lastName: option.value.split(' ')[1] ?? '',
        isArchived: false,
      }}
      sx={sx}
    />
  )
}
